export default {
  panel: {
    panelTooltip: {
      notes:
        'Tooltip for a panel without details in the measure and wear grids; cellId is the position, e.g. B3',
      message: '{{cellId}}: Screen panel',
    },
    tooltip: {
      apertureWidth: {
        notes:
          'Row label in the panel tooltip for the aperture width of the installed screening media',
        message: 'Aperture width',
      },
      transferTo: {
        notes:
          'Value of the relocate row in the panel tooltip at the position the panel is moved away from; position is a cell id like B3',
        message: 'To {{position}}',
      },
      transferFrom: {
        notes:
          'Value of the relocate row in the panel tooltip at the position the panel is moved to; position is a cell id like B3',
        message: 'From {{position}}',
      },
      swapWith: {
        notes:
          'Value of the swap row in the panel tooltip; position is the cell id of the other panel in the swap, like B3',
        message: 'With {{position}}',
      },
      planned: {
        notes:
          'Value of a measurement row in the panel tooltip while the planned measurement has not been recorded yet',
        message: 'Planned',
      },
      unplanned: {
        notes:
          'Chip next to a recorded value or execution status in the panel tooltip when the measurement or action was not planned',
        message: 'Unplanned',
      },
      leftEmpty: {
        notes:
          'Row label in the panel tooltip on the plan and maintenance grids for a position that no screening media covers',
        message: 'Position left empty',
      },
      void: {
        notes:
          'Chip next to "Position left empty" in the panel tooltip; a void is a deck position without screening media',
        message: 'Void',
      },
      notesSection: {
        notes:
          'Heading of the list of notes at the end of the panel tooltip on the plan, measure and maintenance grids',
        message: 'Notes',
      },
    },
    wearRateTooltip: {
      notes:
        'Tooltip for a panel in the wear rate grid; rate is a number with one decimal, unit e.g. "mm/week"',
      message: '{{cellId}}: {{rate}} {{unit}}',
    },
    wearRateCoverageTooltip: {
      notes:
        'Tooltip for a panel in the wear rate grid; coverage is the percentage of the selected period that has measurements',
      message:
        '{{cellId}}: {{rate}} {{unit}}, measured {{coverage}} % of the period',
    },
    wearValueTooltip: {
      notes:
        'Tooltip for a panel in the working depth or aperture width wear grid when the nominal value of its media is unknown; value is in millimetres',
      message: '{{cellId}}: {{value}} mm',
    },
    wearDepthTooltip: {
      notes:
        'Tooltip for a panel in the working depth wear grid; value is in millimetres, percent is the share of the nominal working depth that remains',
      message: '{{cellId}}: {{value}} mm, {{percent}} % of nominal depth',
    },
    wearApertureTooltip: {
      notes:
        'Tooltip for a panel in the aperture width wear grid; value is in millimetres, percent is how much wider than nominal the aperture is (signed, e.g. +15)',
      message: '{{cellId}}: {{value}} mm, {{percent}} % vs nominal width',
    },
  },
  deltaOnly: {
    notes:
      'Toggle button above a panel layout that hides the panels without changes: panels equal to the parent configuration, or panels without planned actions',
    message: 'Delta only',
  },
  executionStatus: {
    pending: {
      notes:
        'Legend label for panels where not all planned actions have been performed yet',
      message: 'Pending',
    },
    performed: {
      notes:
        'Legend label for panels where all planned actions are performed; also the status shown for such actions in the maintenance actions table and the panel tooltip',
      message: 'Performed as planned',
    },
    deviated: {
      notes:
        'Legend label for panels where a planned action was skipped and an unplanned action was performed instead',
      message: 'Performed - deviation',
    },
    unplanned: {
      notes:
        'Legend label for panels where all actions are performed and at least one of them was not planned',
      message: 'Performed - unplanned',
    },
    skipped: {
      notes:
        'Legend label for panels where at least one planned action was skipped',
      message: 'Skipped',
    },
  },
};
